import { Box } from "@react-three/drei";
import { useEffect, useRef } from "react";
import { Vector3, Box3 } from "three";


export const DebugComponents = () => {
  const debugBoxRef = useRef<any>();

  useEffect(() => {
    const windowAlias = window as any;
    windowAlias.debugBoxRef = debugBoxRef;
    windowAlias.printDebugPositions = () => {
      console.log('camera', windowAlias.cameraRef.current.position.toArray());
      console.log('orbit', windowAlias.orbitRef.current.target.toArray());
      console.log('box', windowAlias.debugBoxRef.current.position.toArray());
    }
    windowAlias.debugBoxToTarget = () => {
      windowAlias.debugBoxRef.current.position.set(...windowAlias.orbitRef.current.target.toArray())
    }
  }, [])

  return <>
    <Box args={[0.1, 0.1, 0.1]} position={[0, 0, 0]} ref={debugBoxRef}>
      <meshStandardMaterial attach="material" color="blue" />
    </Box>
  </>
}